import { render, staticRenderFns } from "./SpartanHome.vue?vue&type=template&id=43341b15&scoped=true&"
import script from "./SpartanHome.vue?vue&type=script&lang=js&"
export * from "./SpartanHome.vue?vue&type=script&lang=js&"
import style0 from "./SpartanHome.vue?vue&type=style&index=0&id=43341b15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43341b15",
  null
  
)

export default component.exports